var EmitterConstants = /** @class */ (function () {
    function EmitterConstants() {
    }
    EmitterConstants.INPUT_TRIAL_CODE = 'INPUT_TRIAL_CODE';
    EmitterConstants.BACK_PRESSED = 'BACK_PRESSED';
    EmitterConstants.OPEN_CONDITIONAL_MODAL = 'OPEN_CONDITIONAL_MODAL';
    EmitterConstants.OPEN_INPUT_TRIAL_CODE_MODAL = 'OPEN_INPUT_TRIAL_CODE_MODAL';
    EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL = 'OPEN_TRIAL_SUCCESS_MODAL';
    EmitterConstants.OPEN_TRIAL_COMPARISON_MODAL = 'OPEN_TRIAL_COMPARISON_MODAL';
    EmitterConstants.DOWNGRADE_PACK_IS_TRIAL = 'DOWNGRADE_PACK_IS_TRIAL';
    EmitterConstants.OPEN_TRIAL_ACTIVATION_TIMEOUT = 'OPEN_TRIAL_ACTIVATION_TIMEOUT';
    EmitterConstants.OPEN_TRIAL_MAX_ATTEMPTS_REACHED_MODAL = 'OPEN_TRIAL_MAX_ATTEMPTS_REACHED_MODAL';
    EmitterConstants.BACK_PRESSED_ON_VIDEO = 'BACK_PRESSED_ON_VIDEO';
    return EmitterConstants;
}());
export { EmitterConstants };
